import React from "react"

import GrantHeaderComponent from "./grant-header-component"

class GrantHeaderContainer extends React.Component {

	state = {
		submitting: false
	}

	render() {
		return (
			<GrantHeaderComponent {...this.props} />
		)
	}

}

export default GrantHeaderContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/grants/grant-header-container.js